import { render, staticRenderFns } from "./FormThuxHorizontalText.vue?vue&type=template&id=0ad0401e&"
import script from "./FormThuxHorizontalText.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports